import axios from 'axios'
import queryString from 'query-string'
import { camelizeKeys, decamelizeKeys } from 'humps'

import parse from './parse'
import type {
  FetchFindACourseResponse,
  RawFetchFindACourseResponse,
  RawSeminar,
} from './types'

const CMS_API_BASE = process.env.CMS_API_BASE

type FetchFindACourseParams = {
  country: string
  date: string
  language: string
}

const request = axios.create({
  paramsSerializer: (params) =>
    queryString.stringify(params, { arrayFormat: 'none' }),
})

export default async function fetchFindACourse(
  params: FetchFindACourseParams,
): Promise<FetchFindACourseResponse> {
  const { date, country, language } = params
  const languages = language ? language.split(',') : undefined

  const response = await request.get<RawFetchFindACourseResponse>(
    `${CMS_API_BASE}/seminars/find-a-course`,
    {
      params: decamelizeKeys({
        combineResults: true,
        date,
        country: country || undefined,
        language: languages || undefined,
      }),
    },
  )

  const results = response.data.results.map((s) =>
    parse((camelizeKeys(s) as unknown) as RawSeminar),
  )

  return {
    results,
    country: response.data.country,
  }
}
